import { postRequest, postLoginRequest } from '../../../api/api';
import { aesEncrypt, aesDecrypt } from '../../../utils/crypto';
import toast from 'react-hot-toast';

const notifyError = (message) => {
    toast.error(message, {
        duration: 5000,
    });
};

const client_id_secret = {
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
}

export function postLogin(values, callbackResponse) {
    const encryptedCredentials = aesEncrypt(JSON.stringify(values));
    sessionStorage.setItem('login_token', encryptedCredentials);

    const requestData = {
        grant_type: 'password',
        ...client_id_secret,
        ...values,
    };

    return postRequest(
        '/api/login',
        null,
        requestData,
        callbackResponse
    );
}

export function postOTPLogin(values, callbackResponse, callbackError) {
    try {
        const encryptedCredentials = sessionStorage.getItem('login_token');

        if (!encryptedCredentials) {
            throw new Error(localStorage.getItem('language') === 'en' ? 'User credentials not found' : 'ไม่พบข้อมูลของผู้ใช้งาน');
        }

        const userCredentials = JSON.parse(aesDecrypt(encryptedCredentials));

        const username = userCredentials.username;
        const password = userCredentials.password;

        const requestData = {
            grant_type: 'password',
            ...values,
            ...client_id_secret,
            username: username,
            password: password,
        };

        postLoginRequest(
            '/api/login',
            requestData,
            callbackResponse
        );
    } catch (error) {
        notifyError(localStorage.getItem('language') === 'en' ? 'Resend OTP failed, please try again later' : 'การส่งรหัส OTP ล้มเหลว โปรดลองอีกครั้งในภายหลัง');
    }
}

export function postSendOTP(callbackResponse) {
    try {
        const encryptedCredentials = sessionStorage.getItem('login_token');

        if (!encryptedCredentials) {
            throw new Error(localStorage.getItem('language') === 'en' ? 'User credentials not found' : 'ไม่พบข้อมูลของผู้ใช้งาน');
        }

        const userCredentials = JSON.parse(aesDecrypt(encryptedCredentials));

        const username = userCredentials.username;

        const requestData = {
            grant_type: 'password',
            ...client_id_secret,
            email: username,
        };

        return postRequest(
            '/api/resend-otp-code',
            null,
            requestData,
            callbackResponse
        );
    } catch (error) {
        notifyError(localStorage.getItem('language') === 'en' ? 'Login failed, please try again later' : 'การเข้าสู่ระบบล้มเหลว โปรดลองอีกครั้งในภายหลัง');
    }
}

export function postSendResetPasswordEmail(values, callbackResponse) {
    const requestData = {
        grant_type: 'password',
        ...client_id_secret,
        ...values,
        locale: localStorage.getItem('language'),
        page_url: window.location.origin + '/reset-password',
    };

    return postRequest(
        '/api/send-reset-password-email',
        null,
        requestData,
        callbackResponse
    );
};

export function postValidateResetToken(values, callbackResponse, callbackError) {
    const requestData = {
        grant_type: 'password',
        ...client_id_secret,
        ...values,
    };

    return postRequest(
        '/api/check-password-token-validity',
        null,
        requestData,
        callbackResponse,
        callbackError
    );
};

export function postResetPassword(values, callbackResponse) {
    const requestData = {
        grant_type: 'password',
        ...client_id_secret,
        ...values,
    };

    return postRequest(
        '/api/reset-password',
        null,
        requestData,
        callbackResponse
    );
};